module.exports = __webpack_public_path__ + "files/8b1f5f93802b75a2a3ec5287fd72367a.png";